import MapTool from '@apps-common/ui-maps/MapTool';
import LinkIcon from '@mui/icons-material/Link';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import {showModal} from '../../actions/ui.js';
import {MODALS} from '../../constants/index.js';
import {trackEvent} from '@explorer/analytics';

const LinkShareTool = ({showModal, saveErrors, ...props}) => {
  const {t} = useTranslation();
  const handleClick = () => {
    showModal(MODALS.SHARE);
    trackEvent('Share Link button clicked');
  };

  return (
    <MapTool
      disabled={saveErrors.length > 0}
      tooltipTitle={t('measureTool.tooltipShareSession')}
      icon={<LinkIcon />}
      onClick={handleClick}
      value="session-share-button"
      {...props}
    />
  );
};

LinkShareTool.propTypes = {
  showModal: PropTypes.func,
  saveErrors: PropTypes.array,
};

const mapStateToProps = state => ({
  saveErrors: state.ui.saveState.errors,
});

const mapDispatchProps = {
  showModal,
};

export default connect(mapStateToProps, mapDispatchProps)(LinkShareTool);
